import React from "react";
import "./Features.css";

export default function Features() {
  const items = [
    {
      id: 1,
      pill: "Buy Now",
      label: "Site Vitrines",
      img: "/vitrine.jpg",
    },
    {
      id: 2,
      pill: "Buy Now",
      label: "Site Ecommerce",
      img: "/site2.jpg",
    },
    {
      id: 3,
      pill: "Buy Now",
      label: "Outil de Gestion de stock",
      img: "/gestion.webp",
    },
    {
      id: 4,
      pill: "Buy Now",
      label: "Gestion de livraisons",
      img: "/delivery.webp",
    },
    {
      id: 5,
      pill: "Buy Now",
      label: "Catalogue de Produits",
      img: "/catalog.jpg",
    },
    {
      id: 6,
      pill: "Buy Now",
      label: "Paiements en ligne",
      img: "/payment.jpg",
    },
  ];

  return (
    <section className="featuresWrap-fts">
      <div className="featuresInner-fts">
        {/* TOP */}
        <div className="featuresTop-fts">
          {/* <div className="featuresTitleBlock-fts">
            <h2 className="featuresTitle-fts">
              <span className="featuresTitleLight-fts">Simple à déployer</span>{" "}
              <span className="featuresTitleLight-fts">et à prendre en main,</span>
              <br />
              <span className="featuresTitleBold-fts">
                Adoptez{" "}
                <span className="ecoDot-fts" aria-hidden="true" />
                la solution qui vous convient
              </span>
              <br />
              <span className="featuresTitleLight-fts">au meilleur coût</span>
            </h2>
          </div> */}


          
        </div>

        {/* CARDS */}
        <div className="cardsGrid-fts">
          {items.map((it) => (
            <article
              key={it.id}
              className="card-fts"
              style={{ backgroundImage: `url(${it.img})` }}
            >
              
              <div className="cardLabel-fts">
                {it.label.split("\n").map((line, idx) => (
                  <div key={idx}>{line}</div>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
